import Model from '@/models/Model'

export default {
    mixins: [
        Model
    ],

    data() {
        return {
            table: 'users',
            name: 'user',
            class: 'App\\Models\\User',

            dataTable: {
                headerTopComponents: [
                    {
                        component: 'export-component',
                        bind: {
                            href: route('pages.admin.site.users.export'),
				            text: "Exportar Usuarios"
                        },
                        // html: null,
                        // on: {}
                    }
                ],
                headerBottomComponents: [
                    // {
                    //     component: the-component,
                    //     bind: {},
                    //     html: null,
                    //     on: {}
                    // }
                ]
            }
        }
    },

    methods: {
        allWithHasAnyPermission(permissions) {
            return this.loadAll({
                scopes: {
                    permission: permissions,
                    with: 'permissions'
                }
            })
        },

        profile() {
            axios({
                method: 'get',
                url: route('api.profile')
            })
            .then(
                response => this.$set(this.$state, 'user', response.data.user)
            )
            .catch(
                error => this.$alert(Object.values(error.response.data.errors)[0][0], 'Error!', 'error')
            )
        }
    }
}